import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { AuthServiceCustom } from 'src/shared/service/auth.service';

@Component({
    selector: 'FormatLabel',
    template: `
        <label *ngIf="!isLink" #domElement>{{Currency}}<font [ngClass]="isNegative ? 'label-color-red':''" [hidden]="visible == 'false'"> {{textToShow}}</font></label>
        <span *ngIf="isLink" style="color:#2489d8;text-decoration: underline;cursor:pointer;" [hidden]="!visible"><font [ngClass]="isNegative ? 'label-color-red':''"> {{textToShow}}</font></span>
        `,
    standalone: false
})
export class FormatLabelComponent implements OnChanges{

    @Input() Text = '';
    @Input() FormatPattern = '';
    @Input() MaskPattern = '';
    @Input() isLink = false;
    @Input() Currency = '';
    textToShow = '';

    isNegative = false;

    constructor(private authService: AuthServiceCustom) {

    }

    ngOnChanges(changes: any) {
        this.isNegative = false;
        this.textToShow = this.getValueAsDisplayText(this.Text);
    }

    // New setter method to make it uniform
    set Value(value) {
        this.isNegative = false;
        this.Text = value;
        this.textToShow = this.getValueAsDisplayText(this.Text);
    }

    // New setter method to make it uniform
    get Value() {
        return this.Text;
    }

    getValueAsDisplayText(value: any): string {
        if (value == null || (typeof value != 'undefined' && value.toString() == '')) {
            return '';
        }
        if (value == null || value == undefined || value == '') {
            if (this.FormatPattern == '') {
                return '';
            } else {
                value = 0;
            }
        }
        let dblValue = 0;
        let output: string = value.toString();
        if (this.FormatPattern.toLowerCase() == 'shares') {
            if (!isNaN(value)) {
                dblValue = parseFloat(value);
                output = this.authService.getFixedDecimalDigits(dblValue, 2);
                output = this.authService.numberWithCommas(output);
                if (output.startsWith('-')) {
                    output = '(' + output.substring(1) + ')';
                    this.isNegative = true;
                }
            } else {
                return value.toString();
            }
        } else if (this.FormatPattern.toLowerCase() == 'capital' || this.FormatPattern.toLowerCase() == 'amount' ) {
            if (!isNaN(value)) {
                dblValue = parseFloat(value);
                output = this.authService.getFixedDecimalDigits(dblValue, 2);
                output = this.authService.numberWithCommas(output);
                if (output.startsWith('-')) {
                    output = '(' + output.substring(1) + ')';
                    this.isNegative = true;
                }
            } else {
                return value.toString();
            }
        } else if (this.FormatPattern.startsWith('#') || this.FormatPattern.startsWith('$#')) { // $ format exists on CancelCheckSearch page
            dblValue = parseFloat(value);
            let noOfDigitsAfterDecimal = -1;
            if (this.FormatPattern.split('.').length > 1) {
                noOfDigitsAfterDecimal = this.FormatPattern.split('.')[1].length;
                if (this.FormatPattern.endsWith('%')) {
                    noOfDigitsAfterDecimal -= 1;
                }
            }
            output = this.authService.getFixedDecimalDigits(dblValue, noOfDigitsAfterDecimal);
            output = this.authService.numberWithCommas(output);
            if (this.FormatPattern.endsWith('%')) {
                output += '%';
            } else {
                if (output.startsWith('-')) {
                    output = '(' + output.substring(1) + ')';
                    this.isNegative = true;
                }
                if (this.FormatPattern.startsWith('$')) {
                    output = '$' + output;
                }
            }
        } else if (this.FormatPattern.startsWith('0') && this.FormatPattern.indexOf('.') < 0) {
            // Pad left with 0
            const noOfZeroToPrepend = this.FormatPattern.length - output.length;
            for (let i = 0; i < noOfZeroToPrepend; i++) {
                output = '0' + output;
            }
        } else {
            if (this.MaskPattern != '') {
                if (this.MaskPattern == '00/00') {
                    const splittedTextCounts = this.MaskPattern.split('/');
                    const leftsideTextCount = splittedTextCounts[0].length;
                    const rightSideTextCount = splittedTextCounts.length > 1 ? splittedTextCounts[1].length : 0;
                    return output.substring(0, leftsideTextCount) + '/' + output.substring(leftsideTextCount);
                } else if (this.MaskPattern == '(999) 000-0000' && output.indexOf('(') == -1 && output.indexOf(')') == -1 && output.indexOf(')') == -1 && output.indexOf('-') == -1 && output.indexOf(' ') == -1) {
                    return '(' + output.substring(0, 3) + ') ' + output.substring(3, 6) + '-' + output.substring(6);
                }
            } else {
                return value;
            }
        }
        return output;
    }
}
